import type { AspectId } from '@/lib/design/types'

export type SizePreset = {
    id: AspectId
    label: string
    width: number
    height: number
    hint: string
}

export const SIZES: Record<AspectId, SizePreset> = {
    '1:1': { id: '1:1', label: 'Square', width: 1080, height: 1080, hint: '1080 x 1080' },
    '4:5': { id: '4:5', label: 'Portrait', width: 1080, height: 1350, hint: '1080 x 1350, most feed space' },
    '3:4': { id: '3:4', label: 'Tall', width: 1080, height: 1440, hint: '1080 x 1440, fills the grid tile' }
}

export const SIZE_LIST: Array<SizePreset> = [SIZES['1:1'], SIZES['4:5'], SIZES['3:4']]

export const isAspect = (value: unknown): value is AspectId => value === '1:1' || value === '4:5' || value === '3:4'

export const getSize = (aspect: AspectId): SizePreset => SIZES[aspect] ?? SIZES['4:5']

// How much of each side the 3:4 profile grid tile cuts away for a given post size.
export const gridCrop = (aspect: AspectId): { side: number, vertical: number } => {
    const { width, height } = getSize(aspect)
    const tileRatio = 3 / 4

    if (width / height > tileRatio) return { side: (width - height * tileRatio) / 2, vertical: 0 }

    return { side: 0, vertical: (height - width / tileRatio) / 2 }
}

// Instagram's current limits, kept in one place.
export const LIMITS = {
    slides: 20,
    caption: 2200,
    hashtags: 5,
    altText: 1000,
    captionPreview: 125
}
